// extracted by css-extract-rspack-plugin
export default {"animate":"_a23bddbb","shimmerLoadingBackground":"_34fb858d"};